<script setup>
import { defineProps, defineEmits } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const props = defineProps({
    actions: {
        type: Object,
        required: true,
        // exemplo esperado:
        // { view: true, edit: "edit", delete: "delete" }
    },
    row: {
        type: Object,
        required: true,
    },
    duplicate: {
        type: Boolean,
        default: false,
    },
    tooltipText: {
        type: String,
        default: "",
    },
    actionTooltipText: {
        type: String,
        default: "",
    },
});

const emit = defineEmits(["on-view", "on-edit", "on-delete", "on-duplicate"]);

function emitAction(eventName, row) {
    if (props.actionTooltipText) return;

    emit(eventName, row);
}
</script>

<template>
    <div class="action-buttons d-flex align-items-center gap-2">
        <button
            v-if="actions.view"
            type="button"
            v-tooltip="actionTooltipText || false"
            @click="emitAction('on-view', row)"
        >
            <i class="material-symbols-outlined">
                visibility
            </i>
        </button>

        <button
            v-if="actions.edit"
            type="button"
            v-tooltip="actionTooltipText || false"
            @click="emitAction('on-edit', row)"
        >
            <i class="material-symbols-outlined text-blue">{{ actions.edit }}</i>
            <span class="d-inline d-sm-none p-5">{{ t("common.labels.edit") }}</span>

        </button>

        <button v-if="row.read_only" type="button">
            <i
                v-tooltip="row.read_only ? tooltipText : ''"
                class="material-symbols-outlined font-weight-bold text-white"
            >
                lock
            </i>
        </button>

        <button
            v-if="duplicate && actions.edit"
            type="button"
            v-tooltip="actionTooltipText || false"
            @click="emitAction('on-duplicate', row)"
        >
            <i class="material-symbols-outlined text-light">content_copy</i>
            <span class="d-inline d-sm-none p-5">{{ t("common.labels.duplicate") }}</span>

        </button>

        <!-- 🗑️ Excluir -->
        <button
            v-if="actions.delete && !row.read_only"
            type="button"
            :class="{ disabled: row.disabled }"
            v-tooltip="actionTooltipText || false"
            @click="!row.disabled && emitAction('on-delete', row)"
        >
            <i class="material-symbols-outlined text-danger">{{ actions.delete }}</i>
            <span class="d-inline d-sm-none p-5">{{ t("common.labels.delete") }}</span>
        </button>
    </div>
</template>

<style scoped>
.action-buttons button {
    background: none;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
}
.action-buttons i {
    font-size: 20px;
}
</style>
